import { render, staticRenderFns } from "./OperModel.vue?vue&type=template&id=38d11e39&scoped=true&"
import script from "./OperModel.vue?vue&type=script&lang=js&"
export * from "./OperModel.vue?vue&type=script&lang=js&"
import style0 from "./OperModel.vue?vue&type=style&index=0&id=38d11e39&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d11e39",
  null
  
)

export default component.exports